module.exports = __webpack_public_path__ + "img/thailand.90e3a858.png";